import { useMemo } from 'react';

// TODO: move to #entities
import { ENOPOrganType } from '#shared';

import { getMatchDetails, toSearchableCase } from '../helpers';

import { useData } from './contexts';

import type { SearchResult } from '../slices';

const organOrder: ENOPOrganType[] = [
  ENOPOrganType.Heart,
  ENOPOrganType.Lungs,
  ENOPOrganType.Liver,
];

export const useCasesSearchResult = () => {
  const { searchText, filteredNewCases, filteredActiveCases } = useData();

  return useMemo<SearchResult[]>(() => {
    const q = searchText.trim();
    if (!q) {
      return [];
    }

    const allCases = [...filteredActiveCases, ...filteredNewCases];
    const seen = new Set<string>();

    const unsorted = allCases
      .map(c => {
        const sc = toSearchableCase(c);
        return {
          label: sc.label ?? '',
          organ: sc.organ,
          details: getMatchDetails(sc, q),
          _key: c?.id ?? sc.label ?? '',
        };
      })
      .filter(r => r.label && r.details.matched)
      .filter(r => (seen.has(r._key) ? false : (seen.add(r._key), true)));

    return unsorted.sort((a, b) => {
      const idxA = a.organ ? organOrder.indexOf(a.organ) : Infinity;
      const idxB = b.organ ? organOrder.indexOf(b.organ) : Infinity;
      return idxA - idxB;
    });
  }, [filteredActiveCases, filteredNewCases, searchText]);
};
